var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.70506 14.718C8.70506 13.494 8.98706 12.396 9.55106 11.424C10.1271 10.452 10.9011 9.696 11.8731 9.156C12.8571 8.604 13.9311 8.328 15.0951 8.328C16.4271 8.328 17.6091 8.658 18.6411 9.318C19.6851 9.966 20.4411 10.89 20.9091 12.09H18.4431C18.1191 11.43 17.6691 10.938 17.0931 10.614C16.5171 10.29 15.8511 10.128 15.0951 10.128C14.2671 10.128 13.5291 10.314 12.8811 10.686C12.2331 11.058 11.7231 11.592 11.3511 12.288C10.9911 12.984 10.8111 13.794 10.8111 14.718C10.8111 15.642 10.9911 16.452 11.3511 17.148C11.7231 17.844 12.2331 18.384 12.8811 18.768C13.5291 19.14 14.2671 19.326 15.0951 19.326C15.8511 19.326 16.5171 19.164 17.0931 18.84C17.6691 18.516 18.1191 18.024 18.4431 17.364H20.9091C20.4411 18.564 19.6851 19.488 18.6411 20.136C17.6091 20.784 16.4271 21.108 15.0951 21.108C13.9191 21.108 12.8451 20.838 11.8731 20.298C10.9011 19.746 10.1271 18.984 9.55106 18.012C8.98706 17.04 8.70506 15.942 8.70506 14.718Z",
  fill: "#FF6F6F"
});

function SvgIconCrab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrab);
export default __webpack_public_path__ + "static/media/Icon_Crab.ffd46f58427cb2cc32a72e3b08a7efe2.svg";
export { ForwardRef as ReactComponent };